import { render, staticRenderFns } from "./fans.vue?vue&type=template&id=5da20e51&scoped=true&"
import script from "./fans.vue?vue&type=script&lang=js&"
export * from "./fans.vue?vue&type=script&lang=js&"
import style0 from "./fans.vue?vue&type=style&index=0&id=5da20e51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da20e51",
  null
  
)

export default component.exports